import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	projectFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recentProjects: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	allProjects: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectFieldLabelGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recentProjectsGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	allProjectsGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	projectFieldLabel: {
		id: 'issue-create.modal.create-form.project-picker.project-field-label',
		defaultMessage: 'Project',
		description: 'Label for project field in issue create form',
	},
	recentProjects: {
		id: 'issue-create.modal.create-form.project-picker.recent-projects',
		defaultMessage: 'Recent Projects',
		description: 'Label for recent projects group in project field',
	},
	allProjects: {
		id: 'issue-create.modal.create-form.project-picker.all-projects',
		defaultMessage: 'All Projects',
		description: 'Label for all projects group in project field',
	},
	projectFieldLabelGalaxia: {
		id: 'issue-create.modal.create-form.project-picker.project-field-label-galaxia',
		defaultMessage: 'Space',
		description: 'Label for project field in issue create form',
	},
	recentProjectsGalaxia: {
		id: 'issue-create.modal.create-form.project-picker.recent-projects-galaxia',
		defaultMessage: 'Recent Spaces',
		description: 'Label for recent projects group in project field',
	},
	allProjectsGalaxia: {
		id: 'issue-create.modal.create-form.project-picker.all-projects-galaxia',
		defaultMessage: 'All Spaces',
		description: 'Label for all projects group in project field',
	},
});
export default messages;
